export const authenticatePasswordlessUserBySMSMutation = `
mutation AuthenticatePasswordlessUserBySMS($input: AuthenticatePasswordlessUserBySMSInput!) {
    authenticatePasswordlessUserBySMS(input: $input) {
        accessToken
        refreshToken
        idToken
        scope
        tokenType
        expiresIn
    }
} 
`;

export const createPasswordlessUserByIdMutation = `
mutation CreatePasswordlessUserById($input: CreatePasswordlessUserByIdInput!) {
    createPasswordlessUserById(input: $input) {
        firstName
        mobile
    }
}
`;
